import { warehousesReducer } from './warehouses.reducer'
export * from './warehouses.types'
export * from './warehouses.actions'
export * from './warehouses.thunks'

export default warehousesReducer
